import React from 'react';

export const BackPage = () => {
  return (
    <div className="backpage">

    </div>
  );
};
